class CifShareController {
  /* @ngInject */
  constructor($state, $uibModalInstance, $http, $timeout, Session, caseId, caseData) {
    this.$state = $state;
    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$timeout = $timeout;
    this.Session = Session;
    this.caseId = caseId;
    this.caseData = caseData;
  }

  $onInit() {
    this.user = this.Session.read('userinfo') || {};
    this.data = {
      email: this.caseData.email,
      ccEmail: this.user.email,
      mobile: '',
      emailBody: '',
    };

    this.$http.get('/client/clientMeta', {
      params: { keyStr: 'CifShare,CifShareSubject,CifShareAttachments' },
    })
      .then(({ data }) => {
        let emailBody = '';
        let emailSubject = '';
        let emailAttachments = [];

        if (data && data.CifShare) {
          emailBody = data.CifShare;
        } else {
          emailBody = `<div>Hi {{full_name}},</div>
          <div><br></div>
          <div>{{clientUserName}} has shared a Candidate Information Form with you.</div>`;
        }

        if (data && data.CifShareSubject) {
          emailSubject = data.CifShareSubject;
        } else {
          emailSubject = '{{full_name}}, Action Required on your Candidate Information Form';
        }

        if (data && data.CifShareAttachments) {
          emailAttachments = data.CifShareAttachments.split(',').map(path => ({
            filename: path.split('/').pop(),
            defaultPath: path,
          }));
        }

        this.data.emailBody = emailBody
          .replace('{{full_name}}', this.caseData.full_name)
          .replace('{{clientUserName}}', this.user.name);
        this.data.emailSubject = emailSubject
          .replace('{{full_name}}', this.caseData.full_name);
        this.data.emailAttachments = emailAttachments;
      });
  }

  validateEmail(email) {
    // eslint-disable-next-line max-len
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  submit(form) {
    if (form.$invalid || this.submitting) return;

    if (
      this.data.ccEmail && this.data.ccEmail.split(',').some(email => !this.validateEmail(email))
    ) {
      this.error = 'Invalid CC Email Addresses';

      this.$timeout(() => {
        this.error = '';
      }, 5000);

      return;
    }

    this.submitting = true;

    this.$http.post(`/case/${this.caseId}/share`, this.data)
      .then(() => {
        this.submitting = false;
        this.success = true;
      })
      .catch(() => (this.submitting = false));
  }
}

export default CifShareController;



// WEBPACK FOOTER //
// ./client/components/cif-share/cif-share-modal.js